/* eslint-disable */
import React, { Component, useState, useEffect } from 'react';
import ReactToPrint from 'react-to-print';
import Workbook from 'react-excel-workbook';
import { Table, Button, Input } from 'antd';
import EditableTable from './EditableTable';
const ExcelFile = Workbook;
const ExcelSheet = Workbook.Sheet;
const ExcelColumn = Workbook.Column;

const CenTable = ({ title, dataSource, columns, onSave }) => {
  const [filters, setFilters] = useState({});

  function get_column_ops(col) {
    const smartLower = (x) => (x && x.toLowerCase) ? x.toLowerCase() : x;
    const sorter = (a, b) => (
      smartLower(a[col.key]) === smartLower(b[col.key]) ?
      0 :
      (smartLower(a[col.key]) > smartLower(b[col.key]) ? 1 : -1)
    );
    let searchInput = undefined;

    return {
      filterDropdown: col.filter && <Input
        ref={r => searchInput = r}
        placeholder={"Filter " + col.title}
        value={filters[col.key]}
        onChange={e => {
          let filters_mut = {...filters}
          filters_mut[col.key] = e.target.value
          setFilters(filters_mut);
        }}
      />,
      filteredValue: filters[col.key] ? [filters[col.key]] : "",
      onFilter: (value, record) => !filters[col.key] || (
        (record[col.key] || record[col.key] === 0) && record[col.key].toString().toLowerCase().indexOf(filters[col.key].toLowerCase()) !== -1
      ),
      onFilterDropdownVisibleChange: (visible) => { if (visible) { setTimeout(() => { searchInput.focus(); }); }},
      sorter: col.sort && (col.sorter || sorter),
      render: col.render || ((text) => {
        const searchText = filters[col.key];
        return searchText ? (
          <span>
            {text.toString().split(new RegExp(`(${searchText})`, 'i')).map((fragment, i) => (
              fragment.toLowerCase() === searchText.toLowerCase()
                ? <span key={i} style={{color: "rgb(64, 184, 255)"}}>{fragment}</span> : fragment
            ))}
          </span>
        ) : text;
      }),
    }
  }

  let datasource = dataSource.map((x, i) => ({...x, key: i}))
  let cols = columns.map(col => ({...col, dataIndex: col.key, ...get_column_ops(col)}))
  cols = cols.map(col => !col.sum ? col : ({...col, title: col.title + " (" +
    datasource.filter(
      row => cols.reduce((keep, col) => keep && col.onFilter(null, row), true)
    ).reduce(
      (a, b) => a + parseFloat(b[col.dataIndex]),
      0,
    ) + ")"}))
  const print_cols = cols.filter(col => col.print);
  const [data, setData] = useState([]);
  useEffect(() => {
    setData(datasource);
  }, [dataSource])
  let print_data = data.filter(row => cols.reduce((keep, col) => keep && col.onFilter(null, row), true))

  const buttonStyle = {
    position: "absolute",
    top: -20,
    right: 0,
    zIndex: 1,
    background: "#f5f5f5",
    borderTop: "none",
    borderRight: "none",
    borderBottom: "none",
    borderRadius: 0,
    padding: 0,
    height: 20,
    width: 80,
  }
  let printRef = undefined;
  return (
    <div
      style={{
        overflowX: 'scroll',
        overflowY: 'hidden',
        whiteSpace: 'nowrap',
      }}
    >

    <ExcelFile filename={title + ".xlsx"} element={<Button style={buttonStyle}>Download</Button>}>
      <ExcelSheet data={print_data} name={title}>
        {print_cols.map(col => <ExcelColumn
          label={col.title}
          key={col.key}
          value={row => row[col.key] === 0 ? "0" : row[col.key]} // workaround for sketchy comparison in exporter code
        />)}
      </ExcelSheet>
    </ExcelFile>
    <ReactToPrint trigger={() => <Button style={{...buttonStyle, width: "50px", right: "80px"}}>Print</Button>} content={() => printRef} />

      { Object.keys(filters).some(k => filters[k]) &&
          <Button
            onClick={() => setFilters({})}
            style={{...buttonStyle, right: "130px", borderColor: "rgb(64, 184, 255)", color: "rgb(64, 184, 255)"}}>
              Clear Filters
          </Button>
      }
      <EditableTable
        title={title}
        data={data}
        setData={setData}
        pagination={data.length > 100 && {
          defaultPageSize: 100,
          pageSizeOptions: ["10", "50", "100", "250"],
          showSizeChanger: true,
          locale: { items_per_page: "" }
        }}
        columns={cols}
        onSave={onSave}
      />
      <div style={{visibility: "hidden", position: "absolute"}}>
        <div ref={r => (printRef = r)}>
          <Table size="small" title={() => title} dataSource={print_data} columns={print_cols.map(col => ({...col, render: null}))} bordered pagination={false} />
        </div>
      </div>
    </div>
  )
}

export default CenTable
